// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyCart_empty-cart__SXPBw {
  max-width: 359px;
  margin-top: 10rem;
}

.EmptyCart_empty-cart__svg__CGCiJ {
  margin-bottom: 4rem;
}

.EmptyCart_empty-cart__title__WMR6g {
  font-size: var(--text-2xl);
  font-weight: 700;
  line-height: 3.2rem;
  color: #000;
  margin-bottom: 2.7rem;
}

.EmptyCart_empty-cart__description__894lf {
  font-size: var(--text-lg);
  font-weight: 500;
  line-height: 2.6rem;
  color: var(--gray-dark);
  margin-bottom: 3rem;
}

.EmptyCart_empty-cart__primary-btn__zdqQu {
  margin-inline: auto;
}

.EmptyCart_empty-cart__shopping-link__5JWw- {
  padding: 1.9rem 11.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Cart/EmptyCart/EmptyCart.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".empty-cart {\n  max-width: 359px;\n  margin-top: 10rem;\n}\n\n.empty-cart__svg {\n  margin-bottom: 4rem;\n}\n\n.empty-cart__title {\n  font-size: var(--text-2xl);\n  font-weight: 700;\n  line-height: 3.2rem;\n  color: #000;\n  margin-bottom: 2.7rem;\n}\n\n.empty-cart__description {\n  font-size: var(--text-lg);\n  font-weight: 500;\n  line-height: 2.6rem;\n  color: var(--gray-dark);\n  margin-bottom: 3rem;\n}\n\n.empty-cart__primary-btn {\n  margin-inline: auto;\n}\n\n.empty-cart__shopping-link {\n  padding: 1.9rem 11.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty-cart": `EmptyCart_empty-cart__SXPBw`,
	"empty-cart__svg": `EmptyCart_empty-cart__svg__CGCiJ`,
	"empty-cart__title": `EmptyCart_empty-cart__title__WMR6g`,
	"empty-cart__description": `EmptyCart_empty-cart__description__894lf`,
	"empty-cart__primary-btn": `EmptyCart_empty-cart__primary-btn__zdqQu`,
	"empty-cart__shopping-link": `EmptyCart_empty-cart__shopping-link__5JWw-`
};
export default ___CSS_LOADER_EXPORT___;
